import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import { ReactNode } from 'react';
import classes from './Toolbar.module.scss';

export default function Toolbar({ children, className, ...rest }: BoxProps) {
  return (
    <Box className={clsx(classes.toolbar, className)} {...rest}>
      {children}
    </Box>
  );
}

export function ToolbarSeparator() {
  return <span className={classes.separator} />;
}

export function LeftGroup({ children }: { children?: ReactNode }) {
  return <div className={classes.leftGroup}>{children}</div>;
}

export function CenterGroup({ children }: { children?: ReactNode }) {
  return <div className={classes.centerGroup}>{children}</div>;
}

export function RightGroup({ children }: { children?: ReactNode }) {
  return <div className={classes.rightGroup}>{children}</div>;
}
